import { render, staticRenderFns } from "./ViewerConfigurationButtons.vue?vue&type=template&id=ed1f7214&"
import script from "./ViewerConfigurationButtons.vue?vue&type=script&lang=ts&"
export * from "./ViewerConfigurationButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports